export enum POI_CATEGORY_GROUP {
  ATTRACTION = 'Attractions',
  RESTAURANT = 'Restaurants',
  CAFE = 'Cafes',
  NIGHTLIFE = 'Nightlife',
  SHOPPING = 'Shopping',
  UNKNOWN = 'Unknown',
  NOTCATEGORIZED = 'NOTCATEGORIZED',
}
